import React from 'react'

import styles from './RadioTabs.module.scss';

export type RadioTabsProps<T extends string> = {
  onChange: Function,
  defaultValue: T,
  tabs: {value: T, title: string}[]
}

export default function RadioTabs<T extends string>({onChange, defaultValue, tabs}: RadioTabsProps<T>) {
  const valueChanged = (e: React.FormEvent<HTMLInputElement>) => onChange(e.currentTarget.value);

  const radioButtons = tabs.map(tab => <RadioTab key={tab.value} onChange={valueChanged} checked={defaultValue === tab.value} title={tab.title} tabValue={tab.value} />);

  return (
    <form className={styles.tabs}>
      { radioButtons }
    </form>
  );
}

type RadioTabProps<T> = {
  onChange: (e: React.FormEvent<HTMLInputElement>) => void,
  checked: boolean,
  tabValue: T,
  title: string
};

function RadioTab<T extends string>({onChange, checked, title, tabValue}: RadioTabProps<T>) {
  return (
    <label className={checked ? styles.activeTab : styles.tab}><input type="radio" value={tabValue} checked={checked} onChange={onChange}/>{ title }</label>
  )
}